import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ILoginUser } from '../../interfaces/dtos/ILoginUser';
import { UserActions } from '../../interfaces/dtos/UserActions';

const initialState: ILoginUser = {
  trainingModeEffectiveDatetime: '',
};

class LoginReducer extends ImmerReducer<ILoginUser> {
  public setLogin(user: Partial<ILoginUser>): void {
    this.draftState = { ...this.draftState, ...user };
    this.draftState.password = '';
  }

  public setLogout(): void {
    this.draftState = initialState;
  }

  public setLockout(): void {
    this.draftState.password = '';
    this.draftState.lockout = true;
  }

  public unlockPos(): void {
    this.draftState.lockout = false;
  }

  public updateUserToken(token: string): void {
    this.draftState.sessionId = token;
  }

  public setUserActions(userActions: UserActions): void {
    this.draftState.userActions = userActions;
  }

  public settrainingModeEffectiveDatetime(dateTimeInput: string): void {
    this.draftState.trainingModeEffectiveDatetime = dateTimeInput;
  }

  public setRefreshSubject(subject: string) {
    this.draftState.workerId = subject;
  }

  public refreshToken(user: Partial<ILoginUser>) {
    if (user.workerId === this.draftState.workerId) {
      this.draftState.sessionId = user.sessionId;
    }
  }
}

export const LoginActions = createActionCreators(LoginReducer);
export const LoginReducerFunction = createReducerFunction(LoginReducer, initialState);
